/* global Office setTimeout clearTimeout */

type OfficeReadyInfo = { host: unknown; platform: unknown };

/**
 * 初期化の通知を待つ上限。
 *
 * **待ちに上限が無いと、通知が来ない環境でタスクペインが永久に白いまま止まる**（記録 37）。
 * `office.js` は `taskpane.html` が Microsoft の CDN から読み込むので、そこへ届かない回線では
 * `Office` そのものが無い。通常の起動は 1 秒に届かないので、10 秒は十分に緩い。
 */
export const OFFICE_READY_TIMEOUT_MS = 10_000;

let readyPromise: Promise<OfficeReadyInfo> | null = null;

/**
 * Office.onReady の解決を Promise で待てるようにする。
 * アプリ全体で 1 度だけ初期化される (singleton)。
 *
 * 待てなかったときは投げる。呼び出し側（`taskpane.tsx` の bootstrap）が理由を画面へ出す。
 */
export function whenOfficeReady(): Promise<OfficeReadyInfo> {
    if (!readyPromise) {
        readyPromise = new Promise((resolve, reject) => {
            if (typeof Office === "undefined" || typeof Office.onReady !== "function") {
                // office.js を読めていない。待っても来ないので、その場で理由を返す。
                reject(new Error("Office の読み込みに失敗しました"));
                return;
            }
            const timer = setTimeout(
                () => reject(new Error("Office の初期化を待てませんでした")),
                OFFICE_READY_TIMEOUT_MS
            );
            Office.onReady((info) => {
                clearTimeout(timer);
                resolve(info as OfficeReadyInfo);
            });
        });
    }
    return readyPromise;
}

/** テスト用。singleton を初期へ戻す。 */
export function __resetWhenOfficeReadyForTest(): void {
    readyPromise = null;
}
